import { apiSlice } from "./apiSlice";
import { FOOD_ITEM_URL } from "../constants";

const foodItemsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createFoodItem: builder.mutation({
      query: (data) => ({
        url: `${FOOD_ITEM_URL}/createFoodItem`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getFoodItemsForCustomers: builder.query({
      query: (data) => ({
        url: `${FOOD_ITEM_URL}/getFoodItemsForCustomers?${
          data?.query ? data?.query : ""
        }`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
    checkFoodItemAvailability: builder.mutation({
      query: (data) => ({
        url: `${FOOD_ITEM_URL}/checkFoodItemAvailability`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    uploadPhoto: builder.mutation({
      query: (data) => ({
        url: `${FOOD_ITEM_URL}/uploadFoodItemPhoto`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateFoodItemMutation,
  useGetFoodItemsForCustomersQuery,
  useCheckFoodItemAvailabilityMutation,
  useUploadPhotoMutation,
} = foodItemsApiSlice;
